import { render, staticRenderFns } from "./CategoryReport.vue?vue&type=template&id=a0696936&scoped=true&"
import script from "./CategoryReport.vue?vue&type=script&lang=js&"
export * from "./CategoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0696936",
  null
  
)

export default component.exports